import { createIcon } from '@chakra-ui/react';

export const CrossIcon = createIcon({
	viewBox: '0 0 12 12',
	d: 'm10.192.3438-4.243 4.242L1.707.3438.293 1.7577l4.242 4.242-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414-4.242-4.242 4.242-4.242-1.414-1.414Z',
});
